import React, { useState, useEffect, useCallback, useTransition, useDeferredValue, useRef } from "react";
// import { motion, AnimatePresence } from "framer-motion";
import {
  MapPin,
  PhoneForwarded,
  Mail,
  Send,
  SendHorizontal,
  ChevronDown,
  X,
} from "lucide-react";
import { DotsPattern } from "../../../assets";
// import {
//   scrollVariantsLeft,
//   scrollVariantsRight,
//   upAndDown,
//   downAndUp,
// } from "../../../constants/TextAnimation";
import { Grid } from "../../ui/Grid";
import { Spotlight } from "../../ui/spotlight-new";
import { cn } from "../../../lib/utils";
import helpers from "../../../lib/crypto";
import Joi from "joi";
import axios from "axios";
import confetti from "canvas-confetti";
import { useFunctionContext } from "../../context/FunctionalContext";
import countryList from "../../../utils/data";

const API_URL = import.meta.env.VITE_API_URL;

const services = [
  "Business Advisory",
  "Finance and Accounting",
  "Real Estate Services",
  "Other",
];

const referredBy = [
  "Wahaj",
  "Rabia",
  "Lysann",
  "Maricel",
  "Bhuvan",
  "Jennifer",
  "Nikola",
  "Other",
];

const Dropdown = React.memo(({ label, options, value, setValue }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      {/* <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label> */}

      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex justify-between items-center px-4 py-3 focus:ring-1 focus:ring-gold placeholder-gray-500 transition-colors duration-200 bg-slate-800/60 border border-gold/10 rounded-md focus:outline-none focus:border-gold caret-gold"
      >
        <span className={value ? "text-white" : "text-gray-500"}>
          {value || `Select ${label}`}
        </span>
        <span className="text-gray-400">▾</span>
      </button>

      {open && (
        <ul
          className="absolute z-20 mt-2 max-h-52 overflow-y-auto w-full rounded-xl bg-slate-800 shadow-lg border border-gray-600 overflow-hidden"
        >
          {options.map((option) => (
            <li
              key={option}
              onClick={() => {
                setValue(option);
                setOpen(false);
              }}
              className="px-4 py-3 hover:bg-slate-700 cursor-pointer text-sm"
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
});

Dropdown.displayName = "Dropdown";

const ContactInfo = React.memo(() => {
  return (
    <div
      className="bg-slate-900/40 rounded-xl py-6 px-6 overflow-hidden relative"
    >
      <Grid size={20} />
      <div className="flex items-center gap-3">
        <div className="w-1 h-6 bg-gradient-to-b from-secondary to-gold rounded-sm" />
        <h3 className="text-lg leading-none font-semibold uppercase text-center">
          contact information
        </h3>
      </div>
      <div className="my-6 h-px bg-gradient-to-r from-gray-400 via-gray to-gray-400 animate-pulse" />

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-8 p-4 px-0">
        <div className="flex justify-start gap-2 items-start">
          <MapPin className="text-gold" size={22} />
          <div>
            <h5 className="uppercase leading-none mb-2 font-semibold text-xl">
              UAE
            </h5>
            <p className="text-sm text-slate-400">
              Office 805, Donna Tower, <br />
              Dubai Silicon Oasis, Dubai, UAE
            </p>
          </div>
        </div>

        <div className="flex justify-start gap-2 items-start">
          <PhoneForwarded className="text-gold" size={22} />
          <div>
            <p className="text-lg leading-none mb-2 font-semibold">
              Phone number (UAE)
            </p>
            <p className="mt-1 text-sm font-medium text-slate-400">
              +971 52 794 7540
            </p>
            <p className="mt-1 text-sm font-medium text-slate-400">
              +971 4 557 9914
            </p>
          </div>
        </div>

        <div className="flex justify-start gap-2 items-start">
          <MapPin className="text-gold" size={22} />
          <div>
            <h5 className="uppercase mb-2 leading-none font-semibold text-xl">
              CANADA
            </h5>
            <p className="text-sm text-slate-400 ">
              Unit 208/209, 3485 Rebecca St, <br />
              Oakville, Ontario, Canada L6L 0H4
            </p>
          </div>
        </div>

        <div className="flex justify-start gap-2 items-start">
          <PhoneForwarded className="text-gold" size={22} />
          <div>
            <p className="text-lg leading-none font-semibold mb-1">
              Phone number (CA)
            </p>
            <div className="flex flex-col">
              <p className="mt-1 text-sm text-slate-400 font-medium">
                +1 416 8848286
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-start gap-2 items-start">
          <MapPin className="text-gold" size={22} />
          <div>
            <h5 className="uppercase mb-2 leading-none font-semibold text-xl">
              United Kingdom
            </h5>
            <p className="text-sm text-slate-400 ">
              Second floor, Berkeley
              <br />
              Square house, London
            </p>
          </div>
        </div>

        <div className="flex justify-start gap-2 items-start">
          <PhoneForwarded className="text-gold" size={22} />
          <div>
            <p className="text-lg leading-none mb-2 font-semibold">
              Phone number (UK)
            </p>
            <p className="mt-1 text-sm font-medium text-slate-400">
              +44 7429 255983
            </p>
          </div>
        </div>

        <div className="flex justify-start gap-2 items-start">
          <Mail size={20} className="mb-1 text-gold" />
          <div>
            <h5 className="mb-1 leading-none font-semibold text-xl">
              Email address
            </h5>
            <p className="text-sm text-slate-400">
              admin@scanglobal.me
            </p>
          </div>
        </div>
      </div>
    </div>
  );
});
ContactInfo.displayName = "ContactInfo";

const LocationsMap = React.memo(() => {
  return (
    <section className="py-10 sm:py-16 lg:pt-24 container">
      <h6
        className="font-semibold text-white pb-3"
      >
        <span className="relative inline-block text-white text-lg tracking-wide">
          Our Locations
          <span className="absolute left-1 bottom-[-0.625rem] w-full h-1 rounded-[3.125rem] bg-gradient-to-r from-secondary to-gold" />
        </span>
      </h6>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10">
        <div
          className="w-full h-[300px] overflow-hidden rounded-xl shadow-lg"
        >
          <iframe
            title="UAE Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3612.5467152879164!2d55.3646988810526!3d25.11720102042485!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f64480aaf180d%3A0x8ae16ec8c6a09322!2sDonna%20Towers%20-%20Dubai%20Silicon%20Oasis%20-%20Dubai%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2sin!4v1747755481997!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="invert"
          ></iframe>
        </div>

        <div
          className="w-full h-[300px] overflow-hidden rounded-xl shadow-lg"
        >
          <iframe
            title="Canada Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2893.3789820664324!2d-79.88297222389274!3d43.515289171109124!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b6fa2218da7f5%3A0xc722d4bca8447e06!2s310%20Main%20St%20E%20%23101%2C%20Milton%2C%20ON%20L9T%202J5%2C%20Canada!5e0!3m2!1sen!2sin!4v1747755599253!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            className="invert"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </section>
  );
});
LocationsMap.displayName = "LocationsMap";

const FeatureSection = React.memo(() => {
  return (
    <section className="py-10 sm:py-16 lg:py-24">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div
          className="grid items-center grid-cols-1 lg:grid-cols-2 gap-x-12 gap-y-12"
        >
          <div className="relative lg:mb-">
            <img
              className="absolute right-16 -bottom-8 xl:-bottom-12 xl:-right- invert"
              src={DotsPattern}
              alt="dots-svg"
            />
            <div className="lg:pl-12 lg:pr-6">
              <img
                className="relative h-[500px] object-cover rounded-xl"
                src="/images/1.jpg"
                alt="about"
              />
            </div>
            <div className="absolute left-0 pr-12 bottom-8 xl:bottom-20">
              <div className="max-w-xs bg-slate-900 rounded-lg sm:max-w-md xl:max-w-md">
                <div className="px-3 py-4 sm:px-5 sm:py-8">
                  <div className="flex items-start">
                    <p className="text-3xl sm:text-4xl">👋</p>
                    <blockquote className="ml-5">
                      <p className="text-sm font-medium text-white sm:text-lg">
                        “Scan Global Supports Your Journey Toward Smart and
                        Secure Financial Growth.”
                      </p>
                    </blockquote>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="2xl:pl-16 relative">
            <h2 className="text-2xl font-bold leading-tight sm:text-4xl lg:text-5xl lg:leading-tight">
              We make things easy for projects.
            </h2>
            <p className="text-base lg:text-xl leading-relaxed text-gray-400 mt-4 lg:mt-9">
              From startup advice and capital raising to global expansion
              and real estate strategy, we simplify every stage of your
              business journey. Our expert guidance helps you protect your
              wealth, reduce your tax liabilities, and unlock opportunities
              for sustainable, international growth—all with clarity and
              confidence.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
});
FeatureSection.displayName = "FeatureSection";

const Contact = () => {
  const { ORG_ID } = useFunctionContext();

  const [loading, setLoading] = useState(false);
  const [service, setService] = useState("");
  const [reference, setReference] = useState("");
  const [selectedCode, setSelectedCode] = useState("+971");
  const [selectedEmoji, setSelectedEmoji] = useState("🇦🇪");
  const [phoneNumberModalOpen, setPhoneNumberModalOpen] = useState(false);
  const searchInputRef = useRef(null);
  const [search, setSearch] = useState(""); // For deferred filtering
  const deferredSearch = useDeferredValue(search);
  const [isPending, startTransition] = useTransition();
  const [visibleCount, setVisibleCount] = useState(30); // Virtual scrolling - show 30 items initially

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    services: "",
    referredBy: "",
    message: "",
  });

  const [errors, setErrors] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);

    // Detect country based on IP
    const detectCountry = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();

        if (data.country_code) {
          const country = countryList.find(c => c.code === data.country_code);
          if (country) {
            setSelectedCode(country.dial_code);
            setSelectedEmoji(country.emoji);
            console.log(`🌍 Auto-detected country via IP: ${country.name} (${country.dial_code})`);
            return;
          }
        }
      } catch (error) {
        console.log('IP detection failed, trying browser geolocation...');
      }

      // Fallback to browser geolocation
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            try {
              const { latitude, longitude } = position.coords;
              // Use reverse geocoding to get country
              const response = await fetch(
                `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
              );
              const data = await response.json();

              if (data.address && data.address.country_code) {
                const countryCode = data.address.country_code.toUpperCase();
                const country = countryList.find(c => c.code === countryCode);
                if (country) {
                  setSelectedCode(country.dial_code);
                  setSelectedEmoji(country.emoji);
                  console.log(`📍 Auto-detected country via GPS: ${country.name} (${country.dial_code})`);
                }
              }
            } catch (error) {
              console.log('Geolocation reverse geocoding failed, using default');
            }
          },
          (error) => {
            console.log('Geolocation permission denied or unavailable, using default');
          }
        );
      }
    };

    detectCountry();
  }, []);

  // Memoized filtered countries with deferred search
  const filteredCountries = React.useMemo(() => {
    return countryList.filter(
      (c) =>
        c.name.toLowerCase().includes(deferredSearch.toLowerCase()) ||
        c.dial_code.includes(deferredSearch)
    );
  }, [deferredSearch]);

  // Reset visible count when search changes
  useEffect(() => {
    setVisibleCount(30);
  }, [deferredSearch]);

  const add_leads = (data) => {
    const schema = Joi.object({
      key: Joi.string().required(),
      source: Joi.string().required(),
      lead_name: Joi.string().trim().min(2).max(30).required(),
      email: Joi.string()
        .trim()
        .min(10)
        .max(55)
        .email({ tlds: { allow: false } }) // disable built-in TLD validation to avoid warning
        .required()
        .messages({
          "string.email": "Please enter a valid email address",
        }),
      admin_type: Joi.string().optional().allow("", null),
      organisation_id: Joi.string().required(),
      comments: Joi.string().optional().allow("", null),
      route_action: Joi.number().valid(1).required(),
      status: Joi.string().trim().valid("New").required(),
      next_follow_up: Joi.date().iso().allow("", null),
      phoneNumber: Joi.string()
        .min(6).max(15)
        .required(),

      services: Joi.string().min(3).max(100).required(),
      referredBy: Joi.string().min(3).max(100).required(),
    });

    return schema.validate(data);
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/[^\d]/g, "").slice(0, 13);

    setFormData((prev) => ({
      ...prev,
      phoneNumber: value,
    }));
  };

  const handleServicesChange = useCallback((val) => {
    setFormData((prev) => ({ ...prev, services: val }));
  }, []);

  const handleReferredByChange = useCallback((val) => {
    setFormData((prev) => ({ ...prev, referredBy: val }));
  }, []);

  const dosubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (
      !formData.name ||
      !formData.email ||
      !formData.phoneNumber ||
      !formData.services ||
      !formData.referredBy
    ) {
      setErrors("Please fill all required fields");
      setLoading(false);
      return;
    }

    const payload = {
      key: "scanglobal",
      source: "Holdings",
      lead_name: formData.name,
      email: formData.email,
      comments: formData.message || "",
      phoneNumber: selectedCode.replace("+", "") + formData.phoneNumber,
      services: formData.services,
      referredBy: formData.referredBy,
      route_action: 1,
      status: "New",
      next_follow_up: new Date().toISOString(),
      admin_type: "1",
      organisation_id: ORG_ID,
    };
    console.log(payload, 'pad')

    const { error } = add_leads(payload);

    if (error) {
      setErrors(error.details[0].message);
      setLoading(false);
      return;
    }

    let encrypted;
    try {
      encrypted = helpers.encryptobj(payload);
      // console.log("📦 Encrypted Payload to Send:", encrypted);
    } catch (e) {
      // console.error("❌ Encryption error:", e);
      setErrors("Encryption failed.");
      setLoading(false);
      return;
    }

    try {
      console.log("🚀 Initiating Axios POST request...");
      const response = await axios.post(
        `${API_URL}/admin/add_update_lead`,
        { enc: encrypted },
        { headers: { "Content-Type": "application/json" } },
      );

      // console.log("✅ Axios Response:", response.data);

      if (response.status === 200) {
        confetti({
          particleCount: 100,
          spread: 70,
          origin: { y: 0.6 },
        });
        setSuccessMessage("Your message has been sent successfully!");
        setErrors("");
        setFormData({
          name: "",
          email: "",
          phoneNumber: "",
          services: "",
          referredBy: "",
          message: "",
        });
      } else {
        setErrors(
          response.data?.message || "Something went wrong on the server",
        );
      }
    } catch (err) {
      console.error("❌ Axios Submit Error:", err);
      if (err.response) {
        setErrors(err.response.data?.message || "Something went wrong on the server");

        console.error("💡 Server Response:", err.response.data);
      }
      setErrors("Something went wrong on the server");

    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = useCallback(({ currentTarget: inp }) => {
    const { name, value } = inp;

    // Immediately update for responsive typing
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Defer the expensive validation
    startTransition(() => {
      let newValue = value;

      if (name === "message") {
        newValue = value.replace(/[^\w\s.\-/:?,]/gi, "");
      }

      if (name === "name") {
        newValue = value.replace(/[^\w\s]/gi, "");
      }

      if (name === "email") {
        newValue = value.replace(/[^a-zA-Z0-9@,. ]/gi, "");
      }

      // Only update if sanitization changed the value
      if (newValue !== value) {
        setFormData((prev) => ({
          ...prev,
          [name]: newValue,
        }));
      }
    });
  }, []);

  // useEffect(() => {
  //   if (!formData?.phoneNumber?.includes("-")) return; // ✅ skip if only number

  //   const [code, number] = formData.phoneNumber.split("-");
  //   const foundCountry = countryList.find((c) => c.dial_code === code);

  //   if (foundCountry) {
  //     setSelectedCode(foundCountry.dial_code);
  //     setSelectedEmoji(foundCountry.emoji);
  //     setFormData((prev) => ({ ...prev, phoneNumber: number }));
  //   }
  // }, [formData?.phoneNumber, countryList]);

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => setSuccessMessage(""), 5000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  return (
    <>
      <div
        className="relative px-4 bg-gradient-to-br from-gold/5 via-transparent"
      >
        <div
          className={cn(
            "absolute inset-0 z-[-1] opacity-30",
            "[background-size:40px_40px]",
            // "[background-image:linear-gradient(to_right,#e4e4e7_1px,transparent_1px),linear-gradient(to_bottom,#e4e4e7_1px,transparent_1px)]",
            "[background-image:linear-gradient(to_right,#262626_1px,transparent_1px),linear-gradient(to_bottom,#262626_1px,transparent_1px)]",
          )}
        />
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center [mask-image:radial-gradient(ellipse_at_center,transparent_20%,black)] bg-[var(--secondary-bg-color)]"></div>
        <Spotlight />
        <section className="py-10 sm:py-16 md:pt-28 lg:pt-52 px-0 md:px-8 relative z-10 container">
          <div
            className="grid grid-cols-1 gap-6 px-8 md:px-0 md:grid-cols-2"
          >
            <div className="flex items-center justify-center">
              {/* Left line */}
              <div className="block h-px w-16 md:w-24 bg-gradient-to-r from-transparent via-gold to-transparent mr-4"></div>

              {/* Text */}
              <h4
                className="text-2xl md:text-4xl text-nowrap font-semibold text-center uppercase"
              // style={{ fontFamily: "Lato", fontWeight: "900" }}
              >
                Contact Us
              </h4>

              {/* Right line */}
              <div className="block h-px w-16 md:w-24 bg-gradient-to-l from-transparent via-gold to-transparent ml-4"></div>
            </div>
            <p className="text-base leading-relaxed text-gray-400">
              If you have any questions, please feel free to get in touch with
              us via phone, text, email the form below, or even social media!
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 mt-10">
            <div
              className="bg-slate-900/40 rounded-xl py-6 px-6"
            >
              <div className="flex items-center gap-3">
                <div className="w-1 h-6 bg-gradient-to-b from-secondary to-gold rounded-sm" />
                <h3 className="text-lg leading-none font-semibold uppercase text-center">
                  Get in touch
                </h3>
              </div>
              <div className="my-6 h-px bg-gradient-to-r from-gray-400 via-gray to-gray-400 animate-pulse" />

              <form action="#" method="POST" className="" onSubmit={dosubmit}>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-5 gap-y-4">
                  {/* Name */}
                  <div>
                    <div className="mt-2.5 relative">
                      <input
                        type="text"
                        name="name"
                        value={formData?.name}
                        onChange={handleInputChange}
                        placeholder="Enter your full name"
                        maxLength={25}
                        className="block w-full px-4 py-3 focus:ring-1 focus:ring-gold placeholder-gray-500 transition-colors duration-200 bg-slate-800/60 border border-gold/10 rounded-md focus:outline-none focus:border-gold caret-gold"
                      />
                    </div>
                  </div>

                  {/* Email */}
                  <div>
                    <div className="mt-2.5 relative">
                      <input
                        type="email"
                        name="email"
                        value={formData?.email}
                        onChange={handleInputChange}
                        placeholder="Enter your Email"
                        className="block w-full px-4 py-3 focus:ring-1 focus:ring-gold placeholder-gray-500 transition-colors duration-200 bg-slate-800/60 border border-gold/10 rounded-md focus:outline-none focus:border-gold caret-gold"
                      />
                    </div>
                  </div>

                  {/* Phone Number */}
                  <div className="lg:col-span-1">
                    <div className="mt-2.5 relative">
                      <div className="flex items-center w-full px-3 py-3 bg-slate-800/60 border border-gold/10 rounded-md focus-within:border-gold transition">
                        {/* Country selector */}
                        <div className="relative">
                          <button
                            type="button"
                            className="flex items-center gap-1 text-sm text-gray-300 pr-2"
                            onClick={() => {
                              setPhoneNumberModalOpen(!phoneNumberModalOpen);
                              setVisibleCount(30); // Reset virtual scroll
                            }}
                          >
                            <span>{selectedEmoji}</span>
                            <span>{selectedCode}</span>
                            <ChevronDown className="size-3" />
                            <span className="mx-1 text-gray-500">|</span>

                          </button>

                          {phoneNumberModalOpen && (
                            <div
                              className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black/60 backdrop-blur-sm transition-opacity duration-300"
                              onClick={() => setPhoneNumberModalOpen(false)}
                            >
                              <div
                                className="w-full max-w-xs bg-slate-900 border border-slate-700 rounded-xl shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <div className="flex items-center justify-between px-2.5 py-2 sm:p-4 border-b border-slate-700 bg-slate-900">
                                  <h3 className="text-white font-semibold text-sm md:text-lg">
                                    Select Country
                                  </h3>
                                  <button
                                    type="button"
                                    onClick={() => setPhoneNumberModalOpen(false)}
                                    className="text-gray-400 hover:text-white transition-colors p-1 hover:bg-slate-800 rounded-full"
                                  >
                                    <X className="size-3 md:size-6" />
                                  </button>
                                </div>
                                <div className="p-3 bg-slate-900 border-b border-slate-700">
                                  <input
                                    ref={searchInputRef}
                                    autoFocus
                                    type="text"
                                    placeholder="Search country..."
                                    defaultValue=""
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      // Only update search state in transition (no re-render of input)
                                      startTransition(() => {
                                        setSearch(value);
                                      });
                                    }}
                                    className="w-full px-3 md:px-4 py-2 md:py-2.5 text-base bg-slate-800 border border-slate-600 rounded-lg focus:outline-none focus:border-gold text-white placeholder-gray-500"
                                  />
                                </div>

                                <div
                                  className="max-h-[40vh] overflow-y-auto"
                                  onScroll={(e) => {
                                    const { scrollTop, scrollHeight, clientHeight } = e.target;
                                    // Load more when scrolled near bottom
                                    if (scrollHeight - scrollTop <= clientHeight * 1.5) {
                                      setVisibleCount(prev => Math.min(prev + 20, filteredCountries.length));
                                    }
                                  }}
                                >
                                  {filteredCountries
                                    .slice(0, visibleCount)
                                    .map((c) => (
                                      <div
                                        key={c.code}
                                        className="px-4 py-2 md:py-3 flex justify-between items-center hover:bg-slate-800 cursor-pointer border-b border-slate-800/50 last:border-0 transition-colors"
                                        onClick={() => {
                                          setSelectedCode(c.dial_code);
                                          setSelectedEmoji(c.emoji);
                                          setPhoneNumberModalOpen(false);
                                          if (searchInputRef.current) {
                                            searchInputRef.current.value = "";
                                          }
                                          setSearch("");
                                        }}
                                      >
                                        <span className="flex items-center gap-3 text-sm md:text-base">
                                          <span className="text-lg md:text-2xl">{c.emoji}</span>{" "}
                                          <span className="text-gray-200 font-medium ">
                                            {c.name}
                                          </span>
                                        </span>
                                        <span className="text-gray-400 font-medium bg-slate-800 px-2 py-1 rounded text-sm">
                                          {c.dial_code}
                                        </span>
                                      </div>
                                    ))}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>

                        {/* Phone input */}
                        <input
                          type="tel"
                          inputMode="numeric"
                          placeholder="Enter contact number"
                          value={formData.phoneNumber}
                          onChange={handlePhoneChange}
                          className="flex-1 bg-transparent text-sm focus:outline-none caret-gold"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Services */}
                  <div>
                    <div className="mt-2.5 relative">
                      <Dropdown
                        label="Services"
                        options={services}
                        value={formData.services}
                        setValue={handleServicesChange}
                      />
                    </div>
                  </div>

                  {/* Referred By */}
                  <div>
                    <div className="mt-2.5 relative">
                      <Dropdown
                        label="Referred By"
                        options={referredBy}
                        value={formData.referredBy}
                        setValue={handleReferredByChange}
                      />
                    </div>
                  </div>

                  {/* Message – Full width */}
                  <div className="lg:col-span-2">
                    <div className="mt-2.5 relative">
                      <textarea
                        name="message"
                        onChange={handleInputChange}
                        placeholder="Text here"
                        rows="4"
                        value={formData?.message}
                        className="block w-full px-4 py-3 focus:ring-1 focus:ring-gold placeholder-gray-500 transition-colors duration-200 bg-slate-800/60 border border-gold/10 rounded-md focus:outline-none focus:border-gold caret-gold"
                      />
                    </div>
                  </div>

                  {/* Submit Button & Messages – Full width */}
                  <div className="lg:col-span-2 text-center">
                    <button
                      type="submit"
                      disabled={loading}
                      className={`px-16 py-2 mt-2 text-base flex items-center gap-2 font-semibold transition-all duration-200 bg-gradient rounded-md focus:outline-none uppercase mx-auto ${loading ? "opacity-50 cursor-not-allowed" : ""
                        }`}
                    >
                      {loading ? "Sending..." : "Send message"}
                      {loading ? (
                        <span className="h-4 w-4 border-2 border-slate-900 border-t-transparent rounded-full animate-spin"></span>
                      ) : (
                        <SendHorizontal size={20} className="text-slate-900" />
                      )}
                    </button>

                    {/* Error */}
                    {errors && (
                      <p className="mt-4 text-sm text-red-400 font-medium text-left">
                        {errors}
                      </p>
                    )}

                    {/* Success */}
                    {successMessage && (
                      <p className="mt-4 text-base text-green-400 font-medium text-left">
                        {successMessage}
                      </p>
                    )}
                  </div>
                </div>
              </form>
            </div>

            {/* contact info */}
            <ContactInfo />
          </div>
        </section>

        {/* map */}
        <LocationsMap />

        <FeatureSection />


        {errors && (
          <p className="mt-2 text-sm text-red-400 font-medium text-center">
            {errors}
          </p>
        )}
      </div>
    </>
  );
};

export default Contact;
